<template>
	<div class="container">
		<div class="content">
			<div v-show="mode === 'list'" class="list_container">
				<h3 class="title mb_20">
					{{ $t('rtr_activity-c2c.title1') }}
				</h3>
				<div class="d_flex align_items_end mb_20">
					<!-- 시작,종료 날짜데이터 -->
					<div class="info mr_10">
						<p class="mb_10">{{ $t('rtr_activity.start') }}</p>
						<date-picker
							is-required
							v-model="startDate"
							:model-config="{ type: 'string' }"
							:locale="$store.state.common.locale"
						>
							<template v-slot="{ inputValue, inputEvents }">
								<label class="calendar_area">
									<input
										class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
										:value="inputValue"
										v-on="inputEvents"
										:disabled="!canFilter"
									/>
								</label>
							</template>
						</date-picker>
					</div>
					<div class="info mr_10">
						<p class="mb_10">{{ $t('rtr_activity.end') }}</p>
						<date-picker
							is-required
							v-model="endDate"
							:model-config="{ type: 'string' }"
							:locale="$store.state.common.locale"
						>
							<template v-slot="{ inputValue, inputEvents }">
								<label class="calendar_area">
									<input
										class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
										:value="inputValue"
										v-on="inputEvents"
										:disabled="!canFilter"
									/>
								</label>
							</template>
						</date-picker>
					</div>

					<!-- 암호자산 선택 -->
					<div class="select_area mr_10" v-show="selectedTab === 2">
						<select
							v-model="assetSeq"
							class="asset_area"
							:disabled="!canFilter"
						>
							<option :value="null">
								{{ $t('input.placeholder.all_assets') }}
							</option>
							<option
								v-for="item in accounts"
								:key="item.seq"
								:value="item.asset_seq"
							>
								{{ item.asset_title }}
							</option>
						</select>
						<span class="select_icon"></span>
					</div>
				</div>

				<!-- 탭메뉴 -->
				<ul class="tab_area mb_20">
					<li
						:class="[{ selected: selectedTab === 1 }, 'buy']"
						@click="selectedTab = 1"
					>
						<a>{{ $t('rtr_activity-c2c.tab1') }}</a>
					</li>
					<li
						:class="[{ selected: selectedTab === 2 }, 'sell']"
						@click="selectedTab = 2"
					>
						<a>{{ $t('rtr_activity-c2c.tab2') }}</a>
					</li>
				</ul>

				<!-- 테이블 시작 -->
				<div v-if="selectedTab === 1">
					<Purchase
						@showDetail="showApplicationDetail"
						:start-date="startDate"
						:end-date="endDate"
					></Purchase>
				</div>
				<div v-if="selectedTab === 2">
					<div v-show="dealMode === 'list'">
						<Sale
							@showDetailList="showDealDetailList"
							:start-date="startDate"
							:end-date="endDate"
							:asset-seq="assetSeq"
						></Sale>
					</div>
					<div v-if="dealMode === 'dealDetailList'">
						<SaleDetailList
							@showDealList="dealMode = 'list'"
							@showDetail="showApplicationDetail"
							:deal-seq="dealSeq"
						></SaleDetailList>
					</div>
				</div>
			</div>
			<div v-if="mode === 'applicationDetail'" class="card">
				<PurchaseDetail
					:init-info="applicationInfo"
					@showList="mode = 'list'"
				></PurchaseDetail>
			</div>
			<div v-if="mode === 'dealDetail'" class="card">
				<SaleDetail
					:init-info="applicationInfo"
					@showList="mode = 'list'"
				></SaleDetail>
			</div>
		</div>
	</div>
</template>

<script>
import Purchase from '@/components/User/Activity/Purchase';
import PurchaseDetail from '@/components/User/Activity/PurchaseDetail';
import Sale from '@/components/User/Activity/Sale';
import SaleDetailList from '@/components/User/Activity/SaleDetailList';
import SaleDetail from '@/components/User/Activity/SaleDetail';
import { mapGetters } from 'vuex';
export default {
	name: 'C2c',
	components: {
		Purchase,
		PurchaseDetail,
		Sale,
		SaleDetailList,
		SaleDetail,
	},
	data() {
		return {
			selectedTab: 1,
			assetSeq: null,
			startDate: this.$dayjs(new Date()).add(-1, 'month').toDate(),
			endDate: new Date(),
			mode: 'list',
			dealMode: 'list',
			applicationInfo: {},
			dealSeq: null,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		canFilter() {
			return this.dealMode === 'list';
		},
	},
	watch: {
		selectedTab() {
			this.assetSeq = null;
			this.dealMode = 'list';
		},
	},
	methods: {
		showApplicationDetail(applicationInfo) {
			this.applicationInfo = applicationInfo;
			if (this.selectedTab === 1) {
				this.mode = 'applicationDetail';
			} else if (this.selectedTab) {
				this.mode = 'dealDetail';
			}
		},
		showDealDetailList(dealSeq) {
			this.dealSeq = dealSeq;
			this.dealMode = 'dealDetailList';
		},
	},
};
</script>
<style scoped></style>
